import { useState, useEffect } from "react";

const useDeliveryData = (initialData) => {
  const [data, setData] = useState(initialData);

  // Helper function to get delivery types
  const getDeliveriesTypes = (deliveryTypeTitle) => {
    const deliveryType = initialData.find((d) => d.title === deliveryTypeTitle);
    return deliveryType ? deliveryType : [];
    // return initialData.map((delivery) => delivery.title);
  };

  // Helper function to get years for a specific delivery type
  const getYears = (deliveryTypeTitle) => {
    const deliveryType = initialData.find((d) => d.title === deliveryTypeTitle);
    return deliveryType ? deliveryType.years : [];
  };

  const getSelectedYears = (deliveryTypeTitle) => {
    const deliveryType = initialData.find((d) => d.title === deliveryTypeTitle);

    return deliveryType
      ? deliveryType.years.find((d) => d.isselected === true)
      : [];
  };

  // Helper function to get months for a specific year in a delivery type
  const getMonths = (deliveryTypeTitle, yearName) => {
    const deliveryType = initialData.find((d) => d.title === deliveryTypeTitle);
    if (!deliveryType) return [];

    const year = deliveryType.years.find((y) => y.yearname === yearName);
    return year ? year.months : [];
  };

  const getSelectedMonths = (deliveryTypeTitle, yearName) => {
    const deliveryType = initialData.find((d) => d.title === deliveryTypeTitle);
    if (!deliveryType) return [];

    const year = deliveryType.years.find((d) => d.isselected === true);
    const month = deliveryType
      ? year.months.find((d) => d.isselected === true)
      : [];
    return month ? month : [];
  };

  return {
    getDeliveriesTypes,
    getYears,
    getSelectedYears,
    getMonths,
    getSelectedMonths,
  };
};

export default useDeliveryData;
